<template>
  <div ref="lottieContainer" class="lottie-container"></div>
</template>

<script>
import lottie from 'lottie-web';
import animationData from '@/assets/Json/skywork_animation.json'; // 导入你的 JSON 动画文件路径

export default {
  mounted() {
    // 创建一个新的 Lottie 实例并播放动画
    this.animation = lottie.loadAnimation({
      container: this.$refs.lottieContainer,
      renderer: 'svg', // 选择渲染器，可以是 'svg' 或者 'canvas'
      loop: true, // 是否循环播放动画
      autoplay: true, // 是否自动播放动画
      animationData: animationData // 动画数据，即你的 JSON 动画
    });
  },
  beforeDestroy() {
    // 在组件销毁前停止并销毁动画
    this.animation.destroy();
  }
};
</script>

<style>
.lottie-container{
  height: 80px;
  width: 80px;
}
</style>
